'use client';

import { createStore } from 'jotai';

// Create a singleton store
const store = createStore();

export { store };
